/**
 * Copyright (c) 2020-2021 Perficient, Inc.
 * Unauthorized copying or distribution of this file prohibited without the express permission of Perficient.
 */
import { useState, useCallback, useEffect } from "react";

const connectInstance = window.connect;
let currentAgent = null;

/**
 * Subscribes to the current contact the agent is viewing and
 * exposes action that can be executed for that contact.
 */
export const useCurrentContactActions = () => {
	const [contact, setContact] = useState(undefined);

	useEffect(() => {
		const agentSubscription = window.connect.agent((agent) => {
			currentAgent = agent;
		});

		const events = window.connect.core.getEventBus();
		const viewContactSubscription = events.subscribe(window.connect.ContactEvents.VIEW, async (event) => {
			if (currentAgent) {
				const contact = currentAgent.getContacts().find((contact) => contact.contactId === event.contactId);
				setContact(contact);
			}
		});
		return () => {
			agentSubscription.unsubscribe();
			viewContactSubscription.unsubscribe();
			currentAgent = null;
		};
	}, []);

	const transferToNumber = useCallback(
		(phoneNumber) => {
			const endpoint = connectInstance.Endpoint.byPhoneNumber(phoneNumber);
			return new Promise((resolve, reject) => {
				contact.addConnection(endpoint, {
					success: resolve,
					failure: reject,
				});
			});
		},
		[contact],
	);

	const callToNumber = useCallback((phoneNumber) => {
		const endpoint = connectInstance.Endpoint.byPhoneNumber(phoneNumber);
		return new Promise((resolve, reject) => {
			currentAgent.connect(endpoint, {
				success: resolve,
				failure: reject,
			});
		});
	}, []);

	return { transferToNumber, callToNumber };
};
